import { useMemo } from 'react';
import get from 'lodash/get';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getAuthenticateUser } from '../../../../store/authenticate/selectors';
import { getManagerPermissions } from '../../../../store/settings/selectors';
import { usePermissions } from '../../../../hooks/useCommon';

export function useSchedulePermissions() {
  const { personnel } = useAppSelector(getAuthenticateUser); // Get the authenticated user's details
  const settings = useAppSelector(getManagerPermissions); // Get manager-specific permissions
  const { permissions: localPermissions } = usePermissions(); // General permissions (admin, employee)

  const schedulePermissions = useMemo(() => {
    const isManager = personnel.permissionLevel === 'Manager'; // Determine if the user is a manager

    // Schedules permissions
    const canManageSchedules = get(settings, 'actions.schedules.manage');
    const canManageTimeoff = get(settings, 'actions.timeoff.manage');
    const canViewSalaryData = get(settings, 'visibility.schedules.salaryData');
    const canViewSchedules = get(settings, 'visibility.schedules.view');

    return {
      isAllowManage: localPermissions.isAdmin || (isManager && canViewSchedules && canManageSchedules),
      isAllowManageTimeoff: localPermissions.isAdmin || (isManager && canManageSchedules && canManageTimeoff),
      isAllowViewSalaryData: localPermissions.isAdmin || (isManager && canViewSalaryData && canViewSchedules),
    };
  }, [personnel.permissionLevel, settings, localPermissions]);

  return {
    schedulePermissions,
  };
}
